import { RouterProvider, createBrowserRouter } from "react-router-dom";
import RoutesHandler from "@utils/routes";
import * as Pages from "@pages";

export default function App() {
  const router = createBrowserRouter([
    {
      path: "/login",
      element: <Pages.Login />,
    },
    {
      path: "/logout",
      element: <Pages.Logout />,
    },
    ...RoutesHandler(),
    {
      path: "/404",
      element: <Pages.NotFound />,
    },
    {
      path: "*",
      element: <Pages.NotFound />,
    },
  ]);

  return <RouterProvider router={router} />;
}
